<template>
    <fb-form-body>

            <el-row gutter="20">
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="设备SN"  class="fb-form-item">
                            {{formData.sn}}
                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">

                    <el-form label-position="top">
                        <el-form-item label="设备编号"  class="fb-form-item">
                            {{formData.number}}
                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="厂商" class="fb-form-item">
                            {{formData.mfgDesc}}
                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="设备状态"   class="fb-form-item">
                            {{formData.statusDesc}}
                        </el-form-item>
                    </el-form>

                </el-col>
            </el-row>


            <el-row>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="激活时间"  class="fb-form-item">
                            {{formData.activeTimeStr}}
                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="上次握手时间"  class="fb-form-item">
                            {{formData.devCnctInfo.lastHandTimeStr}}

                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="一共握手次数" class="fb-form-item">
                            {{formData.devCnctInfo.sumHandTimes}}
                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">

                    <el-form label-position="top">
                        <el-form-item label="上次心跳时间"   class="fb-form-item">
                            {{formData.devCnctInfo.lastHbtTimeStr}}
                        </el-form-item>
                    </el-form>


                </el-col>
            </el-row>

            <el-row>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="在线状态"  class="fb-form-item">
                            {{formData.onlineStatusDesc}}
                        </el-form-item>
                    </el-form>

                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="所在服务器"  class="fb-form-item">
                            {{formData.devCnctInfo.server}}
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="流量卡号"  class="fb-form-item">
                            {{formData.simNo}}
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col span="6">
                    <el-form label-position="top">
                        <el-form-item label="测试二维码"  class="fb-form-item">
                           <img style="width: 100px;height: 100px" :src="qrCodeUrl">
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>


        <el-row>
            <el-col span="24">

                <el-tabs v-model="activeTabName" type="border-card">
                    <el-tab-pane label="控制指令" name="cmd">
                        <sp-dev-hyj-cmd-box :sn="formData.sn"></sp-dev-hyj-cmd-box>
                    </el-tab-pane>
                    <el-tab-pane label="设备日志" name="log">
                        <sp-dev-log :dev-sn="formData.sn"></sp-dev-log>
                    </el-tab-pane>

                </el-tabs>

            </el-col>
        </el-row>

    </fb-form-body>
</template>

<script>


    import SpDevLog from "../sp-dev-log/List";
    import SpDevHyjCmdBox from "../../components/spdev-hyj-cmd-box/SpDevHyjCmdBox";
    export default {
        name: "SpdeviceEdit",
        components: {SpDevHyjCmdBox, SpDevLog},
        data() {
            return {
                api:{
                   update:this.$api.spDevice.update,
                   detail:this.$api.spDevice.detail,
                },
                formErrorMsg:{
                    sn: '',
                    number: '',
                    mfg: '',
                    autoNum:'',
                    status: ''
                },
                formData: {
                    code:'',
                    sn: '',
                    number: '',
                    mfg: '',
                    autoNum:'',
                    status: '',
                    activeTimeStr:'',
                    devCnctInfo:'',
                    simNo:''
                },
                activeTabName:'cmd',
                rules: {
                    sn: [
                        {required: true, message: '请输入设备SN码', trigger: 'blur'},
                    ],
                    mfg: [
                        {required: true, message: '请输入设备厂商标识', trigger: 'blur'},
                    ],
                    status: [
                        {required: true, message: '请选择设备状态', trigger: 'blur'},
                    ]
                }
            }
        },
        computed:{
            qrCodeUrl(){
                let data = (this.$api.$base.root + '/spdev-test/index.html#/?sn=' + this.formData.sn);
                return this.$api.spDevAdminCommon.qrCode + '?data=' + encodeURIComponent(data);
            }
        },
        methods: {
            handleSubmit(form) {

                let vm = this;
                vm.$refs[form].validate((valid) => {
                    if (valid) {
                        vm.$http.post(vm.api.update,vm.$qs.stringify(this.formData)).then((resp)=>{

                            if(resp.data.status === 200){
                                vm.$message({
                                    type:'success',
                                    message: resp.data.desc
                                });
                                vm.$router.cgBack();
                            }else if(resp.data.status === 400){
                                if(resp.data.data.errorFields){
                                    resp.data.data.errorFields.forEach(function (a) {

                                        vm.formErrorMsg[a.name] = '';
                                        vm.$nextTick(() => {
                                            vm.formErrorMsg[a.name] = a.message;
                                        });
                                    });
                                }

                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                });
                            }else{
                                vm.$message({
                                    type:"error",
                                    message: resp.data.desc
                                })
                            }

                        });
                        return true;
                    } else {
                        return false;
                    }
                });

            },
            handleReset(form) {
                this.$refs[form].resetFields();
            }
        },

        created() {

            let vm = this;
            this.$http.post(this.api.detail,this.$qs.stringify(this.$route.query)).then(function (resp) {
                vm.formData = resp.data.data.spDevice;

            });

        }
    }
</script>

<style lang="scss" scoped>

    .fb-form-item {
        max-width: 500px;
    }

</style>


<style>

    .editor-item{
         position: relative;
    }

    .editor-item >.el-form-item__content{
        line-height: initial !important;
    }
</style>